@if (message) {
  <div class="message" [ngClass]="getMessageClass('Body')" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="messageHeader" [ngClass]="getMessageClass('Header')">
      <span class="mr-auto">{{message.heading}}</span>
    </div>
    <div class="messageText" [ngClass]="getMessageClass('Body')" >
      {{ message.content }}
    </div>
  </div>
}